import { Box, Container, Typography } from '@mui/material';
import EpisodeList from '@components/episode/EpisodeList';
import EmptyState from '@components/shared/EmptyState';

export default function AllEpisodesPageView({
  episodes,
  loading,
  error,
  onPlayClick
}) {
  if (loading) {
    return <EmptyState type="loading" message="Loading episodes..." />;
  }

  if (error) {
    return <EmptyState type="error" message={error} />;
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: { xs: 3, sm: 4 } }}>
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{ fontSize: { xs: '1.75rem', sm: '2.125rem' }, overflowWrap: 'anywhere' }}
          >
            All Episodes ({episodes.length})
          </Typography>
        </Box>

        {episodes.length === 0 ? (
          <EmptyState type="empty" message="No episodes available yet." />
        ) : (
          <EpisodeList
            episodes={episodes}
            onPlayClick={onPlayClick}
          />
        )}
      </Box>
    </Container>
  );
}
